import { defineMessages } from 'react-intl';

export default defineMessages({
    twiaAccountNumber: {
        id: 'billing.payment-methods.TWIA Account Number',
        defaultMessage: 'TWIA Account',
    },
    pleaseSelectAccount: {
        id: 'billing.payment-methods.Please Select Account',
        defaultMessage: 'Please Select Account',
    },
    unableToAddPaymentMethodTitle: {
        id: 'billing.payment-methods.Unable to Add Payment Method',
        defaultMessage: 'Unable To Add Payment Method'
    },
    unableToAddPaymentMethodBody: {
        id: 'billing.payment-methods.Unable to Add Payment Method Body',
        defaultMessage: 'Unable to Add Payment Method. Please Contact Admin.'
    },
    deletePaymentMethodTitle: {
        id: 'billing.payment-methods.Delete Payment Method',
        defaultMessage: 'Delete Payment Method'
    },
    deletePaymentMethodDesc: {
          id: 'billing.payment-methods.Do you wish to delete this Payment Method?',
        defaultMessage: 'Do you wish to delete this Payment Method?'
    },
    savedPaymentMethodLimitTitle: {
        id: 'billing.payment-methods.Saved Payment Method Limit',
        defaultMessage: 'Saved Payment Method Limit'
    },
    maxAllowedAPIReached: {
        id: 'billing.payment-methods.Max Allowed API Reached',
        defaultMessage: 'To add an additional payment method, you will need to remove one. You may edit or delete your payment methods on the Manage Payment Methods page.'
    },
    paymentSystemUnavailable: {
        id: 'billing.payment-methods.Payment System Unavailable',
        defaultMessage: 'Payment System Unavailable'
    },
    paymentSystemUnavailableBody: {
        id: 'billing.payment-methods.Payment System Unavailable Body',
        defaultMesage: 'The online payment system is currently unavailable. Please check back later.'
    },
    editPaymentMethod:{
        id: 'billing.payment-methods.Edit Payment Method',
        defaultMessage: 'Edit Payment Method'
    },
    editPaymentGeneralError:{
        id: 'billing.payment-methods.Edit Payment General Error',
        defaultMessage: 'Failed to Load the Payment Method Edit Screen'
    },
    deletePaymentMethodError:{
         id: 'billing.payment-methods.deletePaymentMethodError',
         defaultMessage: 'This payment method is being used for Auto Pay. Please change the payment method for Auto Pay on your policies before deleting this payment method.'
    },
    deletePaymentMethodGeneralError:{
         id: 'billing.payment-methods.Failed to Delete the Payment Method',
         defaultMessage: 'Failed to Delete the Payment Method'
    },
    paymentInstrumentRemoveConfirmYes: {
        id: 'billing.payment-methods.Yes',
        defaultMessage: 'Yes',
    },
    paymentInstrumentRemoveConfirmNo: {
        id: 'billing.payment-methods.No',
        defaultMessage: 'No',
    },
    deleteInstrumentForAutoPay:{
        id: 'billing.payment-methods.Delete Instrument for AutoPay',
        defaultMessage: 'This payment method is being used for Auto Pay. Please change the payment method for Auto Pay on your policies before deleting this Payment Method.'
    },
    paymentCannotProcessed: {
        id: 'policy.view.policy-details.Your Payment Cannot Be Processed At This Time',
        defaultMessage: 'Your Payment Cannot Be Processed At This Time',
    } ,
    pleaseTryAgain: {
        id: 'policy.view.policy-details.Please try again later.',
        defaultMessage: 'Please try again later.',
    },
    yourCardwasDeclinedTitle: {
        id: 'policy.view.policy-details.Your Card was Declined Title',
        defaultMessage: 'Your Card was Declined',
    } ,
    yourCardwasDeclinedBody: {
        id: 'policy.view.policy-details.Your Card was Declined Body',
        defaultMessage: 'Please verify your card information. If the problem persists, please contact your card issuer.',
    },
    duplicatePaymentErrorTitle: {
        id: 'policy.view.policy-details.Duplicate Payment Error Title',
        defaultMessage: 'Duplicate Payment Not Processed',
    } ,
    duplicatePaymentErrorBody: {
        id: 'policy.view.policy-details.Duplicate Payment Error Body',
        defaultMessage: 'A transaction for this amount ({amount}) was already processed today',
    },
    unableToCompletePaymentTitle: {
        id: 'policy.view.policy-details.Unable To Complete Payment Title',
        defaultMessage: 'Your Payment Cannot Be Processed',
    } ,
    unableToCompletePaymentBody: {
        id: 'policy.view.policy-details.Unable To Complete Payment Body',
        defaultMessage: 'Please try again later',
    }, 
    inactivePITitle: {
        id: 'offer.view.offer-details.Inactive PI Title',
        defaultMessage: 'Inactive Payment Method'
    },
    inactivePIBody: {
        id: 'offer.view.offer-details.Inactive PI Body',
        defaultMessage: 'This payment method is inactive, please try another one or add a new one'
    },
    deleted: {
        id: 'billing.payment-methods.Deleted',
        defaultMessage: 'deleted'
    },
})
